import React, { FC } from 'react';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { Field, Icon, Toggle, Tooltip } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import { Attachments } from 'types/Attachments';
type Props = {
  value: Pick<Attachments, 'shareToFeed'>;
  onChange: (
    fn: (attachments: Attachments) => Pick<Attachments, 'shareToFeed'>,
  ) => void;
};

const PostComposerContentInstagramShareToFeed: FC<Props> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Field.Group>
      <Field.Label required>
        {t('instagramShareToFeed.label')}
        <Tooltip content={t('instagramShareToFeed.description')}>
          <Icon
            icon={faCircleInfo}
            size="sm"
            className="tw-ml-1 tw-text-grayscale-100"
          />
        </Tooltip>
        <Toggle
          data-cy="post-composer_instagram-share-to-feed-toggle"
          checked={value.shareToFeed ?? true}
          onChange={() =>
            onChange((prev) => ({ shareToFeed: !(prev.shareToFeed ?? true) }))
          }
          className="tw-ml-auto"
        />
      </Field.Label>
    </Field.Group>
  );
};

export default PostComposerContentInstagramShareToFeed;
